export default "__VITE_ASSET__BwSToOk4__"